import "./App.css";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";

import AboutSection from "./components/About";
import CounterSection from "./components/Counter";
import ExhibitorsSection from "./components/Exhibitors";
import HeroSection from "./components/Hero";
import PartnersSection from "./components/Partners";
import ScheduleSection from "./components/ScheduleV2";
import SpeakersSection from "./components/Speakers";
// import SponsorsSection from "./components/Sponsors";
import TicketsSection from "./components/Tickets";
import Login from "./components/Login";
import WhatsApp from "./components/WhatsAppChat";
import Dashboard from "./components/admin/Dashboard";
import Footer from "./components/Footer";
import CommitteeSection from "./components/Committee";
import Information from "./components/Information";
import SponsorsSection from "./components/Sponsors";
import HotelBookingPage from "./components/booking/HotelBookingPage";
import MainLayout from "./components/booking/MainLayout";
import LinkedInCallback from "./components/LinkedInCallback";
import LinkedInRedirect from "./components/LinkedInRedirect";
import ParticipantsSection from "./components/Participants";
import PanelSurvey from "./components/PanelSurvey";
import ECertificateRequestPage from "./components/ECertificateRequestPage";

function App() {
  return (
    <Router>
      <Routes>
        {/* Main Event Sections */}
        <Route
          path="/"
          element={
            <div className="app">
              <div className="scroll-container">
                <HeroSection />
                <AboutSection />
                <SpeakersSection />
                <SponsorsSection />
                <ExhibitorsSection />
                <ScheduleSection />
                {/* <CounterSection /> */}
                <TicketsSection />
                <ParticipantsSection />
                <PartnersSection />
                <CommitteeSection />
                <Information />
                <Footer />
              </div>
            </div>
          }
        />
        {/* Checkout Page */}
        <Route path="/login" element={<Login />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route
          path="/hotel"
          element={
            <MainLayout>
              <HotelBookingPage />
            </MainLayout>
          }
        />
        <Route path="/survey" element={<PanelSurvey />} />

        <Route path="/linkedin" element={<LinkedInRedirect />} />

        <Route
          path="/thank-you"
          element={
            <div
              style={{ padding: "2rem", textAlign: "center", color: "#fff" }}
            >
              <h1>✅ Thank you for registering!</h1>
              <p>Your LinkedIn post was successful.</p>
            </div>
          }
        />

        <Route path="/ecertificate" element={<ECertificateRequestPage />} />
      </Routes>
      {/* <WhatsApp /> */}
    </Router>
  );
}

export default App;
